<template>
  <div
    class="affixStyle"
    :style="`--paddingLeft:${paddigLeft}px`"
    :class="{isCollapse:!isCollapse}"
  >
    <div class="align-right">
      <slot class="close" name="button" />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'FixBottom',
  data() {
    return {
      active: 0,
    };
  },
  computed: {
    ...mapState({
      isCollapse: (state) => state.isCollapse,
    }),
    paddigLeft() {
      // eslint-disable-next-line no-underscore-dangle
      return window.__POWERED_BY_WUJIE__ ? '20' : '254';
    },
  },
};
</script>

<style lang="scss" scoped>
.affixStyle{
  position: fixed;
  // width: 100%;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 999;
  transition: all 0.3s ease-in-out;
  // &.is-collapse {
  //   left: 64px;
  // }
}
.isCollapse {
  .align-right{
    padding-left: var(--paddingLeft);
  }
}
.align-right {
  text-align: right;
  height: 50px;
  background-color: #ffffff;
  box-shadow: 0px -5px 5px -5px rgba(0, 0, 0, 0.2);
  padding-top: 10px;
  padding-left: 81px;
  box-sizing: border-box;
  padding-right: 30px;
  box-sizing: border-box;
  .close{
    margin-right: 30px;
  }
}
</style>
